<template>
  <div class="teen-page teen6">
    <div class="header">
      <h1>珠穆朗玛峰：世界之巅</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_6.png" alt="珠穆朗玛峰">
        <div class="caption">珠穆朗玛峰，世界之巅，海拔8848.86米</div>
      </div>

      <h2>一、 世界屋脊</h2>
      <p>珠穆朗玛峰是世界上最高的山峰，海拔8848.86米。它位于中国和尼泊尔的边境线上，是喜马拉雅山脉的主峰。珠穆朗玛峰在藏语中意为"大地之母"，是藏族人民心中的神山。</p>

      <h2>二、 地理特征</h2>
      <p>珠峰地区气候极端恶劣，常年积雪，气温极低。山体呈巨型金字塔状，冰川广布。珠峰不仅是登山者的圣地，也是科学家研究地球环境的重要场所。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_6.png" alt="珠峰大本营">
        <div class="caption">珠峰大本营，登山者的起点</div>
      </div>

      <h2>三、 登山历史</h2>
      <p>1953年5月29日，新西兰登山家埃德蒙·希拉里和尼泊尔向导丹增·诺尔盖首次成功登顶珠峰。中国登山队于1960年首次从北坡登顶，创造了人类登山史上的奇迹。</p>

      <h2>四、 中国的攀登</h2>
      <p>中国登山队在珠峰攀登史上创造了多个第一。1975年，中国登山队再次登顶，并精确测量了珠峰高度为8848.13米。2020年，中国测量队再次登顶，精确测量珠峰最新高度为8848.86米。</p>

      <div class="quote-box">
        "山高人为峰。" —— 中国登山精神
      </div>

      <h2>五、 环境保护</h2>
      <p>随着登山者的增多，珠峰地区的环境问题日益严重。中国政府采取了一系列措施保护珠峰生态环境，限制登山人数，组织清理垃圾等，让世界之巅保持纯净。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen6'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f0f4f8;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #1a365d 0%, #2c5282 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #1a365d;
  border-bottom: 2px solid #4299e1;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #ebf8ff;
  padding: 20px;
  border-left: 4px solid #1a365d;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>